/**
 * Rules for reputation deltas across the run loop. Pure functions so they
 * stay easy to test and tune.
 */

export const MAX_REP = 100;
export const MIN_REP = 0;
export const START_REP = 50;

export const REP_VICTORY = 6;
export const REP_DEATH = -22;
export const REP_WEAPON_BROKE = -4;
export const REP_HALL_OF_FAME = 4; // bonus when a weapon hits 3 wins

export type RepTier = 'low' | 'mid' | 'high';

export function clampRep(r: number): number {
  return Math.max(MIN_REP, Math.min(MAX_REP, r));
}

export function tierFor(rep: number): RepTier {
  if (rep < 30) return 'low';
  if (rep > 70) return 'high';
  return 'mid';
}

export function tierLabel(tier: RepTier): string {
  switch (tier) {
    case 'low':
      return 'Struggling';
    case 'mid':
      return 'Respected';
    case 'high':
      return 'Renowned';
  }
}
